<template>
<div class="form">
<a-card :title="c_title">
    <v-gobackbutton v-show="isGuide != 'process'" slot="extra" >返回</v-gobackbutton>
        <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout"  :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-form-model-item label="版本" prop="version">
                <a-radio-group v-model="record.version">
                    <a-radio value="V3.0">
                    3.0
                    </a-radio>
                    <a-radio value="V5.0">
                    5.0
                    </a-radio>
                </a-radio-group>
            </a-form-model-item>
            <a-form-model-item ref="syscode" label="系统编码" prop="syscode">
                <a-input
                    v-if="type"
                    v-model="record.syscode"
                     @blur="
                        () => {
                            $refs.syscode.onFieldBlur();
                        }
                        "
                />
                <span v-else>{{record.syscode}}</span>
            </a-form-model-item>

            <a-form-model-item ref="sysenname" label="英文名称" prop="sysenname">
                <a-input
                    v-model="record.sysenname"
                     @blur="
                        () => {
                            $refs.sysenname.onFieldBlur();
                        }
                        "
                />
            </a-form-model-item>
            <a-form-model-item ref="sysname" label="系统名称" prop="sysname">
                <a-input
                    v-model="record.sysname"
                     @blur="
                        () => {
                            $refs.sysname.onFieldBlur();
                        }
                        "
                />
            </a-form-model-item>
            <a-form-model-item ref="sysproducter" label="产品经理" prop="sysproducter">
                <a-input
                    v-model="record.sysproducter"
                     @blur="
                        () => {
                            $refs.sysproducter.onFieldBlur();
                        }
                        "
                />

            </a-form-model-item>

            <a-form-model-item ref="sysadmin" label="系统负责人" prop="sysadmin">
                <a-input
                    v-model="record.sysadmin"
                     @blur="
                        () => {
                            $refs.sysadmin.onFieldBlur();
                        }
                        "
                />

            </a-form-model-item>
            <a-form-model-item ref="telephone" label="系统负责人手机号" prop="telephone">
                <a-input
                    v-model="record.telephone"
                     @blur="
                        () => {
                            $refs.telephone.onFieldBlur();
                        }
                        "
                />

            </a-form-model-item>
            <a-form-model-item label="系统语言" prop="syslanguage" >
            <a-select v-model="record.syslanguage" placeholder="请选择开发语言" style="width:142px" >
                <a-select-option value="JAVA">
                JAVA
                </a-select-option>
                <a-select-option value="Object-C">
                Object-C
                </a-select-option>
                <a-select-option value=".Net">
                .Net
                </a-select-option>
                <a-select-option value="Vue">
                Vue
                </a-select-option>
                 <a-select-option value="React">
                React
                </a-select-option>
                <a-select-option value="uni-app">
                uni-app
                </a-select-option>
            </a-select>
            </a-form-model-item>
             <a-form-model-item label="领域" prop="domain">
                <a-select v-model="record.domain"  placeholder="" style="width:100px;">
                    <a-select-option value="">
                        全部
                    </a-select-option>
                    <a-select-option value="001">
                        前台
                    </a-select-option>
                    <a-select-option value="002">
                        中台
                    </a-select-option>
                    <a-select-option value="003">
                        开放
                    </a-select-option>
                    <a-select-option value="004">
                        基础
                    </a-select-option>
             </a-select>
            </a-form-model-item>
            <a-form-model-item label="系统分类" prop="syscategory">
                <a-select v-model="record.syscategory"  placeholder="" style="width:150px;">
                    <a-select-option value="">
                        全部
                    </a-select-option>
                    <a-select-option value="Window">
                        Window
                    </a-select-option>
                    <a-select-option value="Android">
                        Android
                    </a-select-option>
                    <a-select-option value="IOS">
                        IOS
                    </a-select-option>
                    <a-select-option value="JAVA-SERVER">
                        JAVA-SERVER
                    </a-select-option>
                    <a-select-option value="H5">
                        H5
                    </a-select-option>
                    <a-select-option value="API">
                        API
                    </a-select-option>
                </a-select>
            </a-form-model-item>

            <a-form-model-item label="所属组织编码" prop="ownercode">
                <a-select v-model="record.ownercode" placeholder="请选择所属组织编码" style="width:181.25px">
                    <a-select-option value="01">
                    南京研发中心
                    </a-select-option>
                    <a-select-option value="02">
                    苏州研发中心
                    </a-select-option>
                </a-select>
            </a-form-model-item>

            <a-form-model-item label="备注" prop="remark" :labelCol="labelCol"
                :wrapperCol="wrapperCol" style="width:100%;margin-top:10px;">
                <a-input v-model="record.remark" type="textarea" />
            </a-form-model-item>

            <a-form-model-item v-show="is_vue_task"  :wrapper-col="{ span: 14, offset: 14 }" >
                <a-button type="primary" @click="handleOk">
                    保存
                </a-button>
                <a-button style="margin-left: 10px;" @click="handleCancel">
                    取消
                </a-button>
            </a-form-model-item>
        </a-form-model>

 </a-card>
</div>

</template>
<script>
import { mapState } from "vuex";
const m_title = {
    'add':'新增系统',
    'detail':'查看系统',
    'edit':'编辑系统',
};
export default {
    data() {
        return {
            c_title:'',
            is_vue_task : true,
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            type:'',
            rules: {
                version:[
                    { required: true, message: '请选择系统版本', trigger: 'blur' },
                ],
                sysname: [
                    { required: true, message: '请输入系统名称', trigger: 'blur' },
                    { min: 1, max: 50, message: '请输入1~50个字符', trigger: 'blur' },
                ],
                sysadmin: [
                    { required: true, message: ' 请输入负责人 ', trigger: 'blur' },
                    { min: 1, max: 50, message: '请输入1~50个字符', trigger: 'blur' },
                ],
                telephone: [
                    { required: true, message: ' 请输入负责人电话,多位负责人电话以，隔开 ', trigger: 'blur' },
                    { min: 1, max: 50, message: '请输入1~50个字符', trigger: 'blur' },
                ],
                syscode:[
                    { required: true, message: '请输入系统编码', trigger: 'blur' },
                    { min: 1, max: 30, message: '请输入1~30个字符', trigger: 'blur' },
                ],
                sysenname:[
                    { required: true, message: '请输入系统名称', trigger: 'blur' },
                    { min: 1, max: 50, message: '请输入1~50个字符', trigger: 'blur' },
                ],
                sysproducter:[
                    { required: true, message: '请输入产品经理姓名', trigger: 'blur' },
                    { min: 1, max: 50, message: '请输入1~50个字符', trigger: 'blur' },
                ],
                syslanguage:[
                    { required: true, message: '请选择开发语言', trigger: 'change'  },
                ],
                syscategory:[
                    { required: true, message: '请选择系统分类', trigger: 'change'  },
                ],
                ownercode:[
                    { required: true, message: '请选择所属组织编码', trigger: 'change'  },
                ],
            },
            confirmLoading: false,
            formItemLayout:'horizontal'
        };
    },
    props:{
        isGuide:String
    },
    computed: {
        ...mapState("sys", {
            record: function(state) {
                return this.action == "add" ? {} : state.record;
            }
        })
    },

    methods: {
        handleOk() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    const { params } = this.$route;
                    if(params.action == 'edit'){
                        //编辑
                        this.record.id = this.record.id;
                        this.$store
                            .dispatch({
                                type: "sys/editSys",
                                params: this.record
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    console.log(response)
                                    this.handleCancel();
                                    this.confirmLoading = false;
                                }
                            });
                    }
                    else if(params.action == 'add'){
                        //新增
                        this.$store
                            .dispatch({
                                type: "sys/addSys",
                                params: this.record
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    console.log(response)
                                    this.handleCancel();
                                }
                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    },

    mounted(){
        const { query, params } = this.$route;
        if(this.isGuide == "process"){
            params.action = "add";
        }
        this.c_title = m_title[params.action];
        this.type = params.action == "add";
        if (params.action != "add") {
            this.$store.dispatch({
                type: "sys/detailSys",
                params: query,
                showMsg: false
            })
        }
        else{
            this.$store.dispatch({
                type: "sys/getEmptySys",
                params: query,
                showMsg: false
            })
        }
        this.is_vue_task = params.action != 'orgdetail'

    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
</style>
